export const WHATSAPP_NUMBER = '5521987940668';

export function buildWhatsAppUrl(message) {
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
}

export function buildWhatsAppPlanUrl(planName) {
  return buildWhatsAppUrl(`Ola! Vim atraves do site e gostaria de saber sobre esse plano: ${planName}.`);
}